// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"0d127898","797":"9a645731","821":"c8991a27"}[chunkId] + ".chunk.js";
};